import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const ChevronLeft = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" className={className} onClick={onClick} ref={ref}>
    <path
      fill="currentColor"
      d="M35 239 229 45c9-10 24-10 34 0l22 22c10 10 10 25 1 34L131 256l155 155c9 9 9 24-1 34l-22 22c-10 10-25 10-34 0L35 273c-10-9-10-25 0-34z"
    />
  </svg>
));
